<template>
    <div class="footer-item">
        <img :src="src" alt="footer Image" class="image">
        <span class="title">{{title}}</span>
        <span class="content">{{content}}</span>
    </div>
</template>

<script>
export default {
  name: 'FooterContactView',
  props: {
    src: String,
    title: String,
    content: String
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/color.scss";

.footer-item{
    width: 250px;
    height: 170px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
        font-weight: 600;
        margin-bottom: 1rem;
        margin-top: 0.5rem;
        color: $black3;
        font-size: 16px;
    }
    .content{
        text-align: center;
        color:#7A8BA6 ;
        margin-bottom: 1rem;
        color: $white2;
        font-size: 16px;
    }
    .image{
        width: 66px;
        height: auto;
    }
}
</style>
